import Rates from 'app/collections/rates';

import Base from 'app/views/base';
import RateListView from 'app/components/pages/shipping_calculator/rate_list';
import ShippingCalculatorFormView from 'app/components/pages/shipping_calculator/form';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize() {
    this.collection = new Rates([], {});
    this.addSubview('form', '#calculator_form', new ShippingCalculatorFormView({ collection: this.collection }));
    this.addSubview('rate_list', '#rate_list', new RateListView({ collection: this.collection }));
  },
});




// WEBPACK FOOTER //
// ./app/components/pages/shipping_calculator/index.js